import {
	createStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {

	const iconStyles: any = {
		height: '100%',
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		color: theme.palette.info.main,
	};

	const inputStyles: any = {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		paddingRight: theme.spacing(1),
		paddingLeft: theme.spacing(6),
		transition: theme.transitions.create('width'),
		width: '100%',
	};

	const inputNonMobileStyles: any = {
		[theme.breakpoints.up('sm')]: {
			width: 120,
			'&:focus': {
				width: 200,
			},
		},
		...inputStyles,
	};

	const inputMobileStyles: any = {
		...inputStyles,
	};

	return createStyles({
		CATSearchBox_grow: {
			flexGrow: 1,
		},
		CATSearchBox_boxWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			height: '100%',
			margin: '0px 20px 0px 10px',
		},
		CATSearchBox_search: {
			position: 'relative',
			borderRadius: theme.shape.borderRadius,
			backgroundColor: alpha(theme.palette.common.black, 0.05),
			transition: '150ms ease-in-out',
			'&:hover': {
				transition: '150ms ease-in-out',
				backgroundColor: alpha(theme.palette.common.black, 0.10),
			},
			marginLeft: 0,
			width: '100%',
			minWidth: '175px',
			[theme.breakpoints.up('sm')]: {
				width: '100%',
			},
		},
		CATSearchBox_searchIcon: {
			width: theme.spacing(6),
			pointerEvents: 'none',
			position: 'absolute',
			top: '0',
			bottom: '0',
			left: '0',
			...iconStyles
		},
		CATSearchBox_searchIconClosed: {
			cursor: 'pointer',
			margin: '0px 20px 0px 10px',
			...iconStyles
		},
		CATSearchBox_closeIcon: {
			width: theme.spacing(6),
			cursor: 'pointer',
			top: '0',
			bottom: '0',
			right: '0',
			...iconStyles
		},
		CATSearchBox_inputRoot: {
			color: theme.palette.info.main,
			width: '100%',
			height: '100%',
		},
		CATSearchBox_inputInput: {
			...inputNonMobileStyles
		},
		CATSearchBox_inputInputMobile: {
			...inputMobileStyles
		},
		CATSearchBox_searchBoxBodyMobile: {
			position: 'absolute',
			top: '0',
			left: '0',
			right: '0',
			bottom: '0',
			zIndex: theme.zIndex.modal,
			padding: '10px',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			background: theme.palette.background.default,
		},
	});
}

export default styles;
